// extracted by mini-css-extract-plugin
export default {"root":"classes_root__vE1x-","links":"classes_links__UqKzW","cursor":"classes_cursor__6sZ1+"};